(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-tabs-slideshows"] && !Shopify.designMode) return;
  try {
    
  class ConceptHeroTabsSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.concept-hero-tabs-slideshow__slide'));
      this.tabs = Array.from(this.querySelectorAll('.concept-hero-tabs-slideshow__tab'));
      this.previousButtons = Array.from(this.querySelectorAll('[data-direction="previous"]'));
      this.nextButtons = Array.from(this.querySelectorAll('[data-direction="next"]'));
      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      this.currentIndex = this.currentIndex < 0 ? 0 : this.currentIndex;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 5000;
      this.remainingTime = this.autoplaySpeed;
      this.startedAt = null;
      this.isVisible = true;

      this.style.setProperty('--hero-progress-duration', `${this.autoplaySpeed}ms`);
      this.setupConceptHeader();
      this.updateCurrentHeight();

      if (this.slides.length < 2) return;

      this.previousButtons.forEach((button) => {
        button.addEventListener('click', () => this.showSlide(this.currentIndex - 1, true, true));
      });

      this.nextButtons.forEach((button) => {
        button.addEventListener('click', () => this.showSlide(this.currentIndex + 1, true, true));
      });

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.showSlide(Number(tab.dataset.slideIndex), true, true));
      });

      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());

      this.blockSelectHandler = (event) => {
        const slide = event.target.closest('.concept-hero-tabs-slideshow__slide');
        if (!slide || !this.contains(slide)) return;

        this.pause();
        this.showSlide(Number(slide.dataset.slideIndex), false);
      };

      document.addEventListener('shopify:block:select', this.blockSelectHandler);
      this.observeVisibility();

      this.play();
    }

    disconnectedCallback() {
      this.pause();
      this.teardownConceptHeader();

      if (this.blockSelectHandler) {
        document.removeEventListener('shopify:block:select', this.blockSelectHandler);
      }

      this.visibilityObserver?.disconnect();
    }

    setupConceptHeader() {
      if (this.dataset.transparentHeader !== 'true') return;

      document.documentElement.classList.toggle('concept-hero-tabs-header-not-sticky', this.dataset.transparentHeaderSticky !== 'true');

      const header = document.querySelector('.header[is="sticky-header"], .header[is="custom-header"], header.header');
      header?.init?.();
    }

    teardownConceptHeader() {
      if (this.dataset.transparentHeader !== 'true') return;

      document.documentElement.classList.remove('concept-hero-tabs-header-not-sticky');

      const header = document.querySelector('.header[is="sticky-header"], .header[is="custom-header"], header.header');
      header?.init?.();
    }

    updateCurrentHeight() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const styles = window.getComputedStyle(activeSlide);
      const desktopHeight = styles.getPropertyValue('--hero-slide-height-desktop').trim();
      const mobileHeight = styles.getPropertyValue('--hero-slide-height-mobile').trim();

      if (desktopHeight) {
        this.style.setProperty('--hero-current-height-desktop', desktopHeight);
      }

      if (mobileHeight) {
        this.style.setProperty('--hero-current-height-mobile', mobileHeight);
      }
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) return;

      this.visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.isVisible = entry.isIntersecting;

          if (this.isVisible) {
            this.play();
          } else {
            this.pause();
          }
        });
      }, { threshold: 0.15 });

      this.visibilityObserver.observe(this);
    }

    scrollActiveTabIntoView(index) {
      const activeTab = this.tabs[index];
      const tabsContainer = activeTab?.parentElement;

      if (!activeTab || !tabsContainer) return;

      const targetLeft = activeTab.offsetLeft - (tabsContainer.clientWidth - activeTab.clientWidth) / 2;
      tabsContainer.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
    }

    showSlide(index, restartAutoplay = true, scrollNavigation = false) {
      const nextIndex = (index + this.slides.length) % this.slides.length;

      if (nextIndex === this.currentIndex) {
        if (restartAutoplay) this.play();
        return;
      }

      this.slides[this.currentIndex].classList.remove('is-active');
      this.slides[this.currentIndex].setAttribute('aria-hidden', 'true');
      this.tabs[this.currentIndex]?.classList.remove('is-active');
      this.tabs[this.currentIndex]?.setAttribute('aria-selected', 'false');

      this.slides[nextIndex].classList.add('is-active');
      this.slides[nextIndex].setAttribute('aria-hidden', 'false');
      this.tabs[nextIndex]?.classList.add('is-active');
      this.tabs[nextIndex]?.setAttribute('aria-selected', 'true');

      if (scrollNavigation) {
        this.scrollActiveTabIntoView(nextIndex);
      }

      this.currentIndex = nextIndex;
      this.updateCurrentHeight();

      this.remainingTime = this.autoplaySpeed;

      if (restartAutoplay) this.play(true);
    }

    play(reset = false) {
      this.pause();
      this.classList.remove('is-paused');

      if (!this.autoplay || !this.isVisible || this.slides.length < 2) return;

      if (reset) {
        this.remainingTime = this.autoplaySpeed;
      }

      this.startedAt = Date.now();
      this.timer = window.setTimeout(() => {
        this.showSlide(this.currentIndex + 1, false);
        this.remainingTime = this.autoplaySpeed;
        this.play(true);
      }, this.remainingTime);
    }

    pause() {
      this.classList.add('is-paused');

      if (!this.timer) return;

      window.clearTimeout(this.timer);
      this.timer = null;

      if (this.startedAt) {
        this.remainingTime = Math.max(0, this.remainingTime - (Date.now() - this.startedAt));
        this.startedAt = null;
      }
    }
  }

  if (!customElements.get('concept-hero-tabs-slideshow')) {
    customElements.define('concept-hero-tabs-slideshow', ConceptHeroTabsSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
